import { useState } from "react";
import { Box, Typography, Alert, Button } from "@mui/material";
import AdminFamilySelect from "components/creation/AdminFamilySelect";
import GridPage from "components/layout/GridPage";
import useIsMobile from "components/hooks/useIsMobile";
import { useSearchParams } from "react-router-dom";
import { useExportFamilyData } from "services/admin";

export default () => {
  const isMobile = useIsMobile();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedFamily, setSelectedFamily] = useState<string | null>(
    searchParams.get("family") || null,
  );
  const [confirmation, setConfirmation] = useState<string | null>(null);
  const { request, loading } = useExportFamilyData();

  const onSelect = (familyRef: string | null) => {
    setSelectedFamily(familyRef);
    setConfirmation(null);
    setSearchParams(familyRef ? { family: familyRef } : {}, { replace: true });
  };

  const onGenerate = async () => {
    if (!selectedFamily) return;
    const response = await request({ familyRef: selectedFamily });
    if (response) {
      setConfirmation(
        "Your export is being generated. A download link will be emailed to you shortly.",
      );
    }
  };

  return (
    <GridPage
      sx={{
        margin: isMobile ? "" : "auto",
        maxWidth: "1000px",
        padding: isMobile ? "20px" : "64px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Typography variant="title">Family Data Export</Typography>
          <Typography variant="body" color="text.secondary">
            Generate a single PDF of everything currently visible to a client —
            documents and tasks (including attachments and the shared
            back-and-forth). We email you a download link when it's ready; the
            link is valid for 30 days.
          </Typography>
        </Box>

        <AdminFamilySelect
          selectedFamily={selectedFamily}
          onChange={onSelect}
          title="Family"
          disabled={loading}
        />

        {selectedFamily && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <Button
              variant="contained"
              onClick={onGenerate}
              disabled={loading}
              sx={{ alignSelf: "flex-start" }}
            >
              {loading ? "Requesting…" : "Email me the export"}
            </Button>
            {confirmation && <Alert severity="success">{confirmation}</Alert>}
          </Box>
        )}
      </Box>
    </GridPage>
  );
};
